import { defineComponent as _defineComponent } from 'vue'
import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import CookieHelper from '@/helpers/CookieHelper'
  import useSegment from '@/composables/useSegment'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GetYourOwnAcademyBanner',
  emits: ['hide-banner'],
  setup(__props, { emit }) {

  

  const { closeIcon } = useIcons()
  const { downloadItem } = useCommonMixin()
  const { getYourOwnAcademyDocumentDownloaded, getYourOwnAcademyBannerClosed } = useSegment()

  const downloadGetYourAcademyDocument = () => {
    getYourOwnAcademyDocumentDownloaded()
    downloadItem('https://s3.eu-central-1.amazonaws.com/static.ketchup.academy/marketing/Eigene%2BFinanz-Akademie.pdf')
  }

  const closeGetYourOwnAcademy = () => {
    getYourOwnAcademyBannerClosed()
    emit('hide-banner')
    CookieHelper.setCrossDomainCookie('hide-get-your-own-academy-banner', 'true')
  }

return { __sfc: true,emit, closeIcon, downloadItem, getYourOwnAcademyDocumentDownloaded, getYourOwnAcademyBannerClosed, downloadGetYourAcademyDocument, closeGetYourOwnAcademy, SVGRenderer, useIcons, useCommonMixin, CookieHelper, useSegment }
}

})